import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton } from "@miro-site/core";
import React from "react";
import styled, { useTheme } from "styled-components";
import { Close } from "../icons/Icons";
var Popup = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var children = _param.children, onCloseClick = _param.onCloseClick, $styles = _param.$styles, props = _object_without_properties(_param, [
        "children",
        "onCloseClick",
        "$styles"
    ]);
    var theme = useTheme();
    return /*#__PURE__*/ _jsxs(PopupWrapper, _object_spread_props(_object_spread({
        ref: ref,
        $p: 20,
        $pt: 70,
        $styles: _object_spread({
            position: "relative",
            borderRadius: [
                0,
                16,
                16,
                16
            ],
            background: "primaryWhite"
        }, $styles)
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                label: "Close popup",
                onClick: function(e) {
                    e.preventDefault();
                    if (onCloseClick) {
                        onCloseClick(e);
                    }
                },
                icon: /*#__PURE__*/ _jsx(Close, {}),
                $styles: {
                    position: "absolute",
                    top: 20,
                    right: 20,
                    borderRadius: "50%",
                    width: 36,
                    height: 36,
                    ":hover": {
                        background: theme.templates.colors.secondary4
                    }
                }
            }),
            children
        ]
    }));
});
Popup.displayName = "Popup";
var PopupWrapper = styled(Box).withConfig({
    componentId: "sc-c80968de-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.templates.elevation.overlay;
});
export default Popup;
